'use strict';

var sign = function sign(number) {
	return number >= 0 ? 1 : -1;
};

module.exports = sign;
